import React from 'react';
import { useTeams } from '../hooks/team';
import SingleTeamTicket from '../components/Tickets/SingleTeamTicket';

export default function TeamTickets() {
  const [teams] = useTeams();
  if (teams) {
    return (
      <div className="row">
        {teams?.map((team) => {
          return <SingleTeamTicket team={team} />;
        })}
      </div>
    );
  }
}
